// Local Constants
import { SprayEventOperatorsIndex } from 'services/sprayEvents/types';
import { RESET_STATE } from '../auth/constants';
import { SPRAY_EVENT_MULTIPLE_OPERATORS_TAB_SET_ACTIVE_INDEX } from './constants';

// Local Types
import { ResetStateAction } from '../auth/types';
import {
    SprayEventMultipleOperatorsTabState,
    SetSprayEventMultipleOperatorsTabIndexAction
} from './types';

const initialState: SprayEventMultipleOperatorsTabState = {
    activeIndex: SprayEventOperatorsIndex.STANDARD
};

export default function (
    state: SprayEventMultipleOperatorsTabState = initialState,
    action: SetSprayEventMultipleOperatorsTabIndexAction | ResetStateAction
): SprayEventMultipleOperatorsTabState {
    switch (action.type) {
        case SPRAY_EVENT_MULTIPLE_OPERATORS_TAB_SET_ACTIVE_INDEX:
            return {
                ...state,
                activeIndex: action.payload
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
